/**
 * AgentAvatar — avatar de agente. Pinta la foto (`avatarUrl`) cuando la hay y,
 * si no existe o falla al cargar, cae a las iniciales sobre un color derivado
 * del nombre. La foto se dibuja ENCIMA de las iniciales (object-fit: cover), de
 * modo que el fallback ya está debajo: si la imagen no carga, aparece sin salto.
 * Usado en Home, LeftRail, RightRail y en el hilo de conversación.
 */

const PALETTE = [
  '#007A33', '#1A6B8A', '#7B3FA0', '#B85C00',
  '#2E7D32', '#1565C0', '#6A1B9A', '#E65100',
]

function colorForName(name) {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return PALETTE[Math.abs(hash) % PALETTE.length]
}

function initials(name) {
  return name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()
}

// ringColor (#280): anillo de identidad de agente (ADR-280 §4 / SPEC §C.2).
// Doble box-shadow: el primer aro repite el color de panel (crea el hueco de
// 2px que separa el anillo de la foto — salva el teal de Cassie en claro),
// el segundo pinta el color real del agente. Sin ringColor: fallback al hash
// de siempre (agentes sin entrada en la paleta, p. ej. Nadia/Omar de Koana).
export function AgentAvatar({ name = '', avatarUrl, size = 32, ringColor }) {
  const style = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: colorForName(name),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size * 0.38,
    fontWeight: 600,
    color: '#fff',
    flexShrink: 0,
    overflow: 'hidden',
    position: 'relative',
    ...(ringColor && {
      boxShadow: `0 0 0 2px var(--color-surface), 0 0 0 3.5px ${ringColor}`,
    }),
  }

  return (
    <div style={style} title={name} aria-label={name}>
      <span>{initials(name)}</span>
      {avatarUrl && (
        <img
          src={avatarUrl}
          alt=""
          aria-hidden="true"
          decoding="async"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            // Las fotos son retrato (ficha ~3:4); al recortarlas en círculo,
            // sesgamos hacia arriba para encuadrar la cara (igual que el diseño).
            objectPosition: '50% 22%',
          }}
          onError={e => { e.currentTarget.style.display = 'none' }}
        />
      )}
    </div>
  )
}
